import React from 'react';

// Admin dashboard "activity" tab (extracted from AdminPage).
export const AdminActivityTab = ({
  formatDate,
  loginActivity,
}) => (
  <div className="space-y-6">
    {/* Daily Login Summary */}
    <div className="bg-zinc-900/50 rounded-xl border border-zinc-800 overflow-hidden">
      <div className="px-5 py-4 border-b border-zinc-800">
        <h3 className="font-semibold text-white">Logins Per Day</h3>
        <p className="text-xs text-zinc-500 mt-1">Last 30 days (excludes admin)</p>
      </div>
      {loginActivity.daily.length === 0 ? (
        <div className="px-5 py-10 text-center text-zinc-500 text-sm">No login activity yet</div>
      ) : (
        <div className="divide-y divide-zinc-800">
          {loginActivity.daily.map((day) => (
            <div key={day.date} className="px-5 py-4">
              <div className="flex items-center justify-between mb-2">
                <span className="font-medium text-white">{new Date(day.date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}</span>
                <div className="flex items-center gap-4">
                  <span className="text-sm text-orange-400 font-semibold">{day.unique_users} unique</span>
                  <span className="text-sm text-zinc-500">{day.total_logins} total</span>
                </div>
              </div>
              {/* User pills */}
              <div className="flex flex-wrap gap-2 mt-2">
                {day.users.map((u) => (
                  <span key={u.user_id} className="px-2.5 py-1 rounded-full bg-zinc-800 text-xs text-zinc-300">
                    {u.display_name || u.username || u.email}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

    {/* Recent Logins */}
    <div className="bg-zinc-900/50 rounded-xl border border-zinc-800 overflow-hidden">
      <div className="px-5 py-4 border-b border-zinc-800">
        <h3 className="font-semibold text-white">Recent Logins</h3>
      </div>
      {loginActivity.recent.length === 0 ? (
        <div className="px-5 py-10 text-center text-zinc-500 text-sm">No recent logins</div>
      ) : (
        <div className="divide-y divide-zinc-800">
          {loginActivity.recent.slice(0, 50).map((login, idx) => (
            <div key={`${login.email}-${login.logged_in_at}-${idx}`} className="px-5 py-3 flex items-center justify-between hover:bg-zinc-800/30">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-zinc-800 flex items-center justify-center text-xs font-bold text-zinc-400">
                  {(login.display_name || login.username || '?').charAt(0).toUpperCase()}
                </div>
                <div>
                  <p className="text-sm font-medium text-white">{login.display_name || login.username}</p>
                  <p className="text-xs text-zinc-500">{login.email}</p>
                </div>
              </div>
              <span className="text-xs text-zinc-500">{formatDate(login.logged_in_at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);
